import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Bars } from "react-loader-spinner";
import axiosInstance from "../../Shared/axiosInstance"; // استخدم الـ instance الجاهز
import CustomDatePicker from "../CustomDate/CustomDatePicker";


export default function TopSelling() {
  const API = "/Sale/top-selling";

  const [topSelling, setTopSelling] = useState([]);
  const [loading, setLoading] = useState(false);
  const [topCount, setTopCount] = useState(5);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [sortBy, setSortBy] = useState("sales");

  // حساب المجاميع
  const totalQuantitySold = topSelling.reduce((sum, item) => sum + (item.totalQuantitySold || 0), 0);
  const totalSalesCount = topSelling.reduce((sum, item) => sum + (item.numberOfSales || 0), 0);

  // جلب البيانات
  const fetchTopSelling = async () => {
    setLoading(true);
    try {
      const params = { topCount, sortBy };
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;

      const { data } = await axiosInstance.get(API, { params });
      setTopSelling(data?.data || []);
    } catch (err) {
      console.error("خطأ في جلب المنتجات الأكثر مبيعًا:", err);
      Swal.fire("خطأ", "فشل في جلب المنتجات الأكثر مبيعًا", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopSelling();
  }, []);

  // فلترة البيانات
  const handleFilter = () => {
    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      Swal.fire("تحذير", "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية", "warning");
      return;
    }
    fetchTopSelling();
  };

  // إعادة الضبط
  const handleReset = () => {
    setTopCount(5);
    setFromDate("");
    setToDate("");
    setSortBy("sales");
    setTimeout(fetchTopSelling, 150);
  };

  // loading قبل return
  if (loading) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center flex-column">
        <Bars height="80" width="80" color="#2563eb" ariaLabel="loading" />
        <p className="mt-3" style={{ color: "#64748b", fontSize: "18px" }}>
          جاري تحميل المنتجات الأكثر مبيعًا...
        </p>
      </div>
    );
  }

  return (
    <div className="container py-5" style={{ maxWidth: "1400px" }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 mt-5 pt-5">
        <div>
          <h2 style={{ color: "#2563eb", fontWeight: "700", fontSize: "28px", marginBottom: "4px" }}>
            المنتجات الأكثر مبيعًا
          </h2>
          <small style={{ color: "#64748b", fontSize: "14px" }}>
            عرض أعلى {topSelling.length} منتج تم ترتيبها حسب {sortBy === "sales" ? "عدد المبيعات" : "الكمية المباعة"}
          </small>
        </div>
      </div>

      {/* Filters Section */}
      <div
        className="mb-4"
        style={{
          background: "#fff",
          border: "1px solid #dbeafe",
          borderRadius: "8px",
          padding: "20px",
          boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
        }}
      >
        <h5 style={{ color: "#1e40af", fontWeight: "600", fontSize: "16px", marginBottom: "16px" }}>
          خيارات التصفية
        </h5>
        <div className="row g-3">
          <div className="col-md-3">
            <label style={{ color: "#475569", fontSize: "14px", fontWeight: "600", marginBottom: "6px" }}>
              أعلى عدد
            </label>
            <select
              value={topCount}
              onChange={(e) => setTopCount(Number(e.target.value))}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "1px solid #bfdbfe",
                borderRadius: "6px",
                fontSize: "15px",
                color: "#475569",
                outline: "none",
                cursor: "pointer",
                background: "#fff",
              }}
            >
              <option value="5">أفضل 5</option>
              <option value="10">أفضل 10</option>
              <option value="15">أفضل 15</option>
              <option value="20">أفضل 20</option>
              <option value="50">أفضل 50</option>
            </select>
          </div>

          <div className="col-md-2">
            <label style={{ color: "#475569", fontSize: "14px", fontWeight: "600", marginBottom: "6px" }}>
              ترتيب حسب
            </label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "1px solid #bfdbfe",
                borderRadius: "6px",
                fontSize: "15px",
                color: "#475569",
                outline: "none",
                cursor: "pointer",
                background: "#fff",
              }}
            >
              <option value="sales">عدد المبيعات</option>
              <option value="quantity">الكمية المباعة</option>
            </select>
          </div>

<div className="col-md-3">
            <CustomDatePicker
              label="من تاريخ"
              value={fromDate}
              onChange={setFromDate}
              placeholder="اختر تاريخ البداية"
              maxDate={toDate ? new Date(toDate) : null}
            />
          </div>

          <div className="col-md-2">
            <CustomDatePicker
              label="إلى تاريخ"
              value={toDate}
              onChange={setToDate}
              placeholder="اختر تاريخ النهاية"
              minDate={fromDate ? new Date(fromDate) : null}
            />
          </div>

          <div className="col-md-2">
            <label style={{ color: "#475569", fontSize: "14px", fontWeight: "600", marginBottom: "6px" }}>
              الإجراءات
            </label>
            <div className="d-flex gap-2">
              <button
                onClick={handleFilter}
                style={{
                  flex: 1,
                  background: "#2563eb",
                  color: "#fff",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "none",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => e.target.style.background = "#1d4ed8"}
                onMouseOut={(e) => e.target.style.background = "#2563eb"}
              >
                <i className="bi bi-search"></i>
                تصفية
              </button>
              <button
                onClick={handleReset}
                style={{
                  flex: 1,
                  background: "#fff",
                  color: "#475569",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #bfdbfe",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => e.target.style.background = "#f8fafc"}
                onMouseOut={(e) => e.target.style.background = "#fff"}
              >
                <i className="bi bi-arrow-clockwise"></i>
                إعادة ضبط
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Date Range Info */}
      {(fromDate || toDate) && (
        <div
          className="mb-3"
          style={{
            background: "#dbeafe",
            border: "1px solid #93c5fd",
            borderRadius: "6px",
            padding: "12px 16px",
            color: "#1e40af",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          <i className="bi bi-calendar-range me-2"></i>
          عرض البيانات {fromDate && `من ${fromDate}`} {toDate && `إلى ${toDate}`}
        </div>
      )}

      {/* Summary Cards */}
      {topSelling.length > 0 && (
        <div className="row g-3 mb-4">
          <div className="col-md-4">
            <div
              style={{
                background: "#fff",
                border: "1px solid #dbeafe",
                borderRadius: "8px",
                padding: "20px",
                boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
              }}
            >
              <div style={{ color: "#64748b", fontSize: "13px", fontWeight: "600", marginBottom: "8px" }}>
                إجمالي المنتجات
              </div>
              <div style={{ color: "#2563eb", fontSize: "24px", fontWeight: "700" }}>
                {topSelling.length}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div
              style={{
                background: "#fff",
                border: "1px solid #bbf7d0",
                borderRadius: "8px",
                padding: "20px",
                boxShadow: "0 4px 12px rgba(34, 197, 94, 0.15)",
              }}
            >
              <div style={{ color: "#64748b", fontSize: "13px", fontWeight: "600", marginBottom: "8px" }}>
                إجمالي الكمية المباعة
              </div>
              <div style={{ color: "#16a34a", fontSize: "24px", fontWeight: "700" }}>
                {totalQuantitySold.toLocaleString()}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div
              style={{
                background: "#fff",
                border: "1px solid #fef3c7",
                borderRadius: "8px",
                padding: "20px",
                boxShadow: "0 4px 12px rgba(245, 158, 11, 0.15)",
              }}
            >
              <div style={{ color: "#64748b", fontSize: "13px", fontWeight: "600", marginBottom: "8px" }}>
                إجمالي عدد المبيعات
              </div>
              <div style={{ color: "#d97706", fontSize: "24px", fontWeight: "700" }}>
                {totalSalesCount.toLocaleString()}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      {topSelling.length > 0 ? (
        <div className="table-responsive">
          <table
            className="table mb-0"
            style={{
              border: "1px solid #dbeafe",
              borderRadius: "8px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
              textAlign: "center",
            }}
          >
            <thead style={{ background: "#dbeafe" }}>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>المنتج</th>
                <th style={thStyle}>الوصف</th>
                <th style={thStyle}>الفئة</th>
                <th style={thStyle}>العلامة التجارية</th>
                <th style={thStyle}>الكمية المباعة</th>
                <th style={thStyle}>عدد المبيعات</th>
              </tr>
            </thead>
            <tbody>
              {topSelling.map((item, index) => (
                <tr key={item.productId} style={{ background: index % 2 === 0 ? "#f8fafc" : "#ffffff" }}>
                  <td style={tdStyle}>
                    <span
                      style={{
                        background: "#dbeafe",
                        color: "#1e40af",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      {index + 1}
                    </span>
                  </td>
                  <td style={{ ...tdStyle, fontWeight: 700, color: "#2563eb" }}>
                    {item.productName}
                  </td>
                  <td style={tdStyle}>{item.description || "-"}</td>
                  <td style={tdStyle}>
                    <span
                      style={{
                        background: "#dbeafe",
                        color: "#1e40af",
                        padding: "4px 10px",
                        borderRadius: "4px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      {item.categoryName}
                    </span>
                  </td>
                  <td style={tdStyle}>
                    <span
                      style={{
                        background: "#e0e7ff",
                        color: "#4338ca",
                        padding: "4px 10px",
                        borderRadius: "4px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      {item.brandName || "غير متوفر"}
                    </span>
                  </td>
                  <td style={tdStyle}>
                    <span
                      style={{
                        background: "#bbf7d0",
                        color: "#14532d",
                        padding: "6px 12px",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      {item.totalQuantitySold?.toLocaleString()}
                    </span>
                  </td>
                  <td style={tdStyle}>
                    <span
                      style={{
                        background: "#fef3c7",
                        color: "#92400e",
                        padding: "6px 12px",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      {item.numberOfSales?.toLocaleString()}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div
          style={{
            background: "#fff",
            border: "1px solid #dbeafe",
            borderRadius: "8px",
            padding: "60px 20px",
            textAlign: "center",
            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
          }}
        >
          <i
            className="bi bi-bar-chart"
            style={{ fontSize: "64px", color: "#94a3b8", marginBottom: "20px" }}
          ></i>
          <h4 style={{ color: "#475569", fontWeight: "600", marginBottom: "8px" }}>
            لا توجد بيانات مبيعات
          </h4>
          <p style={{ color: "#64748b", fontSize: "15px", marginBottom: 0 }}>
            حاول تعديل الفلاتر لعرض النتائج
          </p>
        </div>
      )}
    </div>
  );
}

// Styles
const thStyle = {
  color: "#1e40af",
  fontSize: "14px",
  padding: "12px 8px",
  fontWeight: "600",
  border: "1px solid #bfdbfe",
};

const tdStyle = {
  padding: "12px 8px",
  border: "1px solid #e0e7ff",
  fontSize: "17px",
  fontWeight: "600",
  color: "#475569",
};
